const CountryMaster = {
    /* Data for searching dropdown */
    othercountries:[
      {
        "label": "AFGHANISTAN",
        "value": "AFG",
      },
      {
        "label": "ALBANIA",
        "value": "ALB"
      },
      {
        "label": "ALGERIA",
        "value": "DZA"
      },
      {
        "label": "AMERICAN SAMOA",
        "value": "ASM"
      },
      {
        "label": "ANDORRA",
        "value": "AND"
      },
      {
        "label": "ANGOLA",
        "value": "AGO"
      },
      {
        "label": "ANGUILLA",
        "value": "AIA"
      },
      {
        "label": "ANTARCTICA",
        "value": "ATA"
      },
      {
        "label": "ANTIGUA AND BARBUDA",
        "value": "ATG"
      },
      {
        "label": "ARGENTINA",
        "value": "ARG"
      },
      {
        "label": "ARMENIA",
        "value": "ARM"
      },
      {
        "label": "ARUBA",
        "value": "ABW"
      },
      {
        "label": "AUSTRALIA",
        "value": "AUS"
      },
      {
        "label": "AUSTRIA",
        "value": "AUT"
      },
      {
        "label": "AZERBAIJAN",
        "value": "AZE"
      },
      {
        "label": "BAHAMAS",
        "value": "BHS"
      },
      {
        "label": "BAHRAIN",
        "value": "BHR"
      },
      {
        "label": "BANGLADESH",
        "value": "BGD"
      },
      {
        "label": "BARBADOS",
        "value": "BRB"
      },
      {
        "label": "BELARUS",
        "value": "BLR"
      },
      {
        "label": "BELGIUM",
        "value": "BEL"
      },
      {
        "label": "BELIZE",
        "value": "BLZ"
      },
      {
        "label": "BENIN",
        "value": "BEN"
      },
      {
        "label": "BERMUDA",
        "value": "BMU"
      },
      {
        "label": "BHUTAN",
        "value": "BTN"
      },
      {
        "label": "BOLIVIA",
        "value": "BOL"
      },
      {
        "label": "BOSNIA AND HERZEGOVINA",
        "value": "BIH"
      },
      {
        "label": "BOTSWANA",
        "value": "BWA"
      },
      {
        "label": "BRAZIL",
        "value": "BRA"
      },
      {
        "label": "BRITISH VIRGIN ISLANDS",
        "value": "VGB"
      },
      {
        "label": "BRUNEI",
        "value": "BRN"
      },
      {
        "label": "BULGARIA",
        "value": "BGR"
      },
      {
        "label": "BURKINA FASO",
        "value": "BFA"
      },
      {
        "label": "BURMA (MYANMAR)",
        "value": "MMR"
      },
      {
        "label": "BURUNDI",
        "value": "BDI"
      },
      {
        "label": "CAMBODIA",
        "value": "KHM"
      },
      {
        "label": "CAMEROON",
        "value": "CMR"
      },
      {
        "label": "CANADA",
        "value": "CAN"
      },
      {
        "label": "CAPE VERDE",
        "value": "CPV"
      },
      {
        "label": "CAYMAN ISLANDS",
        "value": "CYM"
      },
      {
        "label": "CENTRAL AFRICAN REPUBLIC",
        "value": "CAF"
      },
      {
        "label": "CHAD",
        "value": "TCD"
      },
      {
        "label": "CHILE",
        "value": "CHL"
      },
      {
        "label": "CHINA",
        "value": "CHN"
      },
      {
        "label": "CHRISTMAS ISLAND",
        "value": "CXR"
      },
      {
        "label": "COCOS (KEELING) ISLANDS",
        "value": "CCK"
      },
      {
        "label": "COLOMBIA",
        "value": "COL"
      },
      {
        "label": "COMOROS",
        "value": "COM"
      },
      {
        "label": "COOK ISLANDS",
        "value": "COK"
      },
      {
        "label": "COSTA RICA",
        "value": "CRC"
      },
      {
        "label": "CROATIA",
        "value": "HRV"
      },
      {
        "label": "CUBA",
        "value": "CUB"
      },
      {
        "label": "CYPRUS",
        "value": "CYP"
      },
      {
        "label": "CZECH REPUBLIC",
        "value": "CZE"
      },
      {
        "label": "DEMOCRATIC REPUBLIC OF THE CONGO",
        "value": "COD"
      },
      {
        "label": "DENMARK",
        "value": "DNK"
      },
      {
        "label": "DJIBOUTI",
        "value": "DJI"
      },
      {
        "label": "DOMINICA",
        "value": "DMA"
      },
      {
        "label": "DOMINICAN REPUBLIC",
        "value": "DOM"
      },
      {
        "label": "ECUADOR",
        "value": "ECU"
      },
      {
        "label": "EGYPT",
        "value": "EGY"
      },
      {
        "label": "EL SALVADOR",
        "value": "SLV"
      },
      {
        "label": "EQUATORIAL GUINEA",
        "value": "GNQ"
      },
      {
        "label": "ERITREA",
        "value": "ERI"
      },
      {
        "label": "ESTONIA",
        "value": "EST"
      },
      {
        "label": "ETHIOPIA",
        "value": "ETH"
      },
      {
        "label": "FALKLAND ISLANDS",
        "value": "FLK"
      },
      {
        "label": "FAROE ISLANDS",
        "value": "FRO"
      },
      {
        "label": "FIJI",
        "value": "FJI"
      },
      {
        "label": "FINLAND",
        "value": "FIN"
      },
      {
        "label": "FRANCE",
        "value": "FRA"
      },
      {
        "label": "FRENCH POLYNESIA",
        "value": "PYF"
      },
      {
        "label": "GABON",
        "value": "GAB"
      },
      {
        "label": "GAMBIA",
        "value": "GMB"
      },
      {
        "label": "GAZA STRIP",
        "value": "/"
      },
      {
        "label": "GEORGIA",
        "value": "GEO"
      },
      {
        "label": "GERMANY",
        "value": "DEU"
      },
      {
        "label": "GHANA",
        "value": "GHA"
      },
      {
        "label": "GIBRALTAR",
        "value": "GIB"
      },
      {
        "label": "GREECE",
        "value": "GRC"
      },
      {
        "label": "GREENLAND",
        "value": "GRL"
      },
      {
        "label": "GRENADA",
        "value": "GRD"
      },
      {
        "label": "GUAM",
        "value": "GUM"
      },
      {
        "label": "GUATEMALA",
        "value": "GTM"
      },
      {
        "label": "GUINEA",
        "value": "GIN"
      },
      {
        "label": "GUINEA-BISSAU",
        "value": "GNB"
      },
      {
        "label": "GUYANA",
        "value": "GUY"
      },
      {
        "label": "HAITI",
        "value": "HTI"
      },
      {
        "label": "HOLY SEE (VATICAN CITY)",
        "value": "VAT"
      },
      {
        "label": "HONDURAS",
        "value": "HND"
      },
      {
        "label": "HONG KONG",
        "value": "HKG"
      },
      {
        "label": "HUNGARY",
        "value": "HUN"
      },
      {
        "label": "ICELAND",
        "value": "IS"
      },
      {
        "label": "INDIA",
        "value": "IND"
      },
      {
        "label": "INDONESIA",
        "value": "IDN"
      },
      {
        "label": "IRAN",
        "value": "IRN"
      },
      {
        "label": "IRAQ",
        "value": "IRQ"
      },
      {
        "label": "IRELAND",
        "value": "IRL"
      },
      {
        "label": "ISLE OF MAN",
        "value": "IMN"
      },
      {
        "label": "ISRAEL",
        "value": "ISR"
      },
      {
        "label": "ITALY",
        "value": "ITA"
      },
      {
        "label": "IVORY COAST/Côte d'Ivoire",
        "value": "CIV"
      },
      {
        "label": "JAMAICA",
        "value": "JAM"
      },
      {
        "label": "JAPAN",
        "value": "JPN"
      },
      {
        "label": "JERSEY",
        "value": "JEY"
      },
      {
        "label": "JORDAN",
        "value": "JOR"
      },
      {
        "label": "KAZAKHSTAN",
        "value": "KAZ"
      },
      {
        "label": "KENYA",
        "value": "KEN"
      },
      {
        "label": "KIRIBATI",
        "value": "KIR"
      },
      {
        "label": "KOSOVO",
        "value": "NIL2"
      },
      {
        "label": "KUWAIT",
        "value": "KWT"
      },
      {
        "label": "KYRGYZSTAN",
        "value": "KGZ"
      },
      {
        "label": "LAOS",
        "value": "LAO"
      },
      {
        "label": "LATVIA",
        "value": "LVA"
      },
      {
        "label": "LEBANON",
        "value": "LBN"
      },
      {
        "label": "LESOTHO",
        "value": "LSO"
      },
      {
        "label": "LIBERIA",
        "value": "LBR"
      },
      {
        "label": "LIBYA",
        "value": "LBY"
      },
      {
        "label": "LIECHTENSTEIN",
        "value": "LIE"
      },
      {
        "label": "LITHUANIA",
        "value": "LTU"
      },
      {
        "label": "LUXEMBOURG",
        "value": "LUX"
      },
      {
        "label": "MACAU",
        "value": "MAC"
      },
      {
        "label": "MACEDONIA",
        "value": "MKD"
      },
      {
        "label": "MADAGASCAR",
        "value": "MDG"
      },
      {
        "label": "MALAWI",
        "value": "MWI"
      },
      {
        "label": "MALAYSIA",
        "value": "MYS"
      },
      {
        "label": "MALDIVES",
        "value": "MDV"
      },
      {
        "label": "MALI",
        "value": "MLI"
      },
      {
        "label": "MALTA",
        "value": "MLT"
      },
      {
        "label": "MARSHALL ISLANDS",
        "value": "MHL"
      },
      {
        "label": "MAURITANIA",
        "value": "MRT"
      },
      {
        "label": "MAURITIUS",
        "value": "MUS"
      },
      {
        "label": "MAYOTTE",
        "value": "MYT"
      },
      {
        "label": "MEXICO",
        "value": "MEX"
      },
      {
        "label": "MICRONESIA",
        "value": "FSM"
      },
      {
        "label": "MOLDOVA",
        "value": "MDA"
      },
      {
        "label": "MONACO",
        "value": "MCO"
      },
      {
        "label": "MONGOLIA",
        "value": "MNG"
      },
      {
        "label": "MONTENEGRO",
        "value": "MNE"
      },
      {
        "label": "MONTSERRAT",
        "value": "MSR"
      },
      {
        "label": "MOROCCO",
        "value": "MAR"
      },
      {
        "label": "MOZAMBIQUE",
        "value": "MOZ"
      },
      {
        "label": "NAMIBIA",
        "value": "NAM"
      },
      {
        "label": "NAURU",
        "value": "NRU"
      },
      {
        "label": "NEPAL",
        "value": "NPL"
      },
      {
        "label": "NETHERLANDS",
        "value": "NLD"
      },
      {
        "label": "NETHERLANDS ANTILLES",
        "value": "ANT"
      },
      {
        "label": "NEW CALEDONIA",
        "value": "NCL"
      },
      {
        "label": "NEW ZEALAND",
        "value": "NZL"
      },
      {
        "label": "NICARAGUA",
        "value": "NIC"
      },
      {
        "label": "NIGER",
        "value": "NER"
      },
      {
        "label": "NIGERIA",
        "value": "NGA"
      },
      {
        "label": "NIUE",
        "value": "NIU"
      },
      {
        "label": "NORFOLK ISLAND",
        "value": "NFK"
      },
      {
        "label": "NORTH KOREA",
        "value": "PRK"
      },
      {
        "label": "NORTHERN MARIANA ISLANDS",
        "value": "MNP"
      },
      {
        "label": "NORWAY",
        "value": "NOR"
      },
      {
        "label": "OMAN",
        "value": "OMN"
      },
      {
        "label": "PAKISTAN",
        "value": "PAK"
      },
      {
        "label": "PALAU",
        "value": "PLW"
      },
      {
        "label": "PALESTINIAN TERRITORY (OCCUPIED)",
        "value": "PSE"
      },
      {
        "label": "PANAMA",
        "value": "PAN"
      },
      {
        "label": "PAPUA NEW GUINEA",
        "value": "PNG"
      },
      {
        "label": "PARAGUAY",
        "value": "PRY"
      },
      {
        "label": "PERU",
        "value": "PER"
      },
      {
        "label": "PHILIPPINES",
        "value": "PHL"
      },
      {
        "label": "PITCAIRN ISLANDS",
        "value": "PCN"
      },
      {
        "label": "POLAND",
        "value": "POL"
      },
      {
        "label": "PORTUGAL",
        "value": "PRT"
      },
      {
        "label": "PUERTO RICO",
        "value": "PRI"
      },
      {
        "label": "QATAR",
        "value": "QAT"
      },
      {
        "label": "REPUBLIC OF THE CONGO",
        "value": "COG"
      },
      {
        "label": "ROMANIA",
        "value": "ROU"
      },
      {
        "label": "RUSSIA",
        "value": "RUS"
      },
      {
        "label": "RWANDA",
        "value": "RWA"
      },
      {
        "label": "SAINT BARTHELEMY",
        "value": "BLM"
      },
      {
        "label": "SAINT HELENA",
        "value": "SHN"
      },
      {
        "label": "SAINT KITTS AND NEVIS",
        "value": "KNA"
      },
      {
        "label": "SAINT LUCIA",
        "value": "LCA"
      },
      {
        "label": "SAINT MARTIN",
        "value": "MAF"
      },
      {
        "label": "SAINT PIERRE AND MIQUELON",
        "value": "SPM"
      },
      {
        "label": "SAINT VINCENT AND THE GRENADINES",
        "value": "VCT"
      },
      {
        "label": "SAMOA",
        "value": "WSM"
      },
      {
        "label": "SAN MARINO",
        "value": "SMR"
      },
      {
        "label": "SAO TOME AND PRINCIPE",
        "value": "STP"
      },
      {
        "label": "SAUDI ARABIA",
        "value": "SAU"
      },
      {
        "label": "SENEGAL",
        "value": "SEN"
      },
      {
        "label": "SERBIA",
        "value": "SRB"
      },
      {
        "label": "SEYCHELLES",
        "value": "SYC"
      },
      {
        "label": "SIERRA LEONE",
        "value": "SLE"
      },
      {
        "label": "SINGAPORE",
        "value": "SGP"
      },
      {
        "label": "SLOVAKIA",
        "value": "SVK"
      },
      {
        "label": "SLOVENIA",
        "value": "SVN"
      },
      {
        "label": "SOLOMON ISLANDS",
        "value": "SLB"
      },
      {
        "label": "SOMALIA",
        "value": "SOM"
      },
      {
        "label": "SOUTH AFRICA",
        "value": "ZAF"
      },
      {
        "label": "SOUTH KOREA",
        "value": "KOR"
      },
      {
        "label": "SPAIN",
        "value": "ESP"
      },
      {
        "label": "SRI LANKA",
        "value": "LKA"
      },
      {
        "label": "SUDAN",
        "value": "SDN"
      },
      {
        "label": "SURIlabel",
        "value": "SUR"
      },
      {
        "label": "SVALBARD",
        "value": "SJM"
      },
      {
        "label": "SWAZILAND",
        "value": "SWZ"
      },
      {
        "label": "SWEDEN",
        "value": "SWE"
      },
      {
        "label": "SWITZERLAND",
        "value": "CHE"
      },
      {
        "label": "SYRIA",
        "value": "SYR"
      },
      {
        "label": "TAIWAN",
        "value": "TWN"
      },
      {
        "label": "TAJIKISTAN",
        "value": "TJK"
      },
      {
        "label": "TANZANIA",
        "value": "TZA"
      },
      {
        "label": "THAILAND",
        "value": "THA"
      },
      {
        "label": "TIMOR-LESTE",
        "value": "TLS"
      },
      {
        "label": "TOGO",
        "value": "TGO"
      },
      {
        "label": "TOKELAU",
        "value": "TKL"
      },
      {
        "label": "TONGA",
        "value": "TON"
      },
      {
        "label": "TRINIDAD AND TOBAGO",
        "value": "TTO"
      },
      {
        "label": "TUNISIA",
        "value": "TUN"
      },
      {
        "label": "TURKEY",
        "value": "TUR"
      },
      {
        "label": "TURKMENISTAN",
        "value": "TKM"
      },
      {
        "label": "TURKS AND CAICOS ISLANDS",
        "value": "TCA"
      },
      {
        "label": "TUVALU",
        "value": "TUV"
      },
      {
        "label": "UGANDA",
        "value": "UGA"
      },
      {
        "label": "UKRAINE",
        "value": "UKR"
      },
      {
        "label": "UNITED ARAB EMIRATES",
        "value": "ARE"
      },
      {
        "label": "UNITED KINGDOM",
        "value": "GBR"
      },
      {
        "label": "UNITED STATES",
        "value": "USA"
      },
      {
        "label": "URUGUAY",
        "value": "URY"
      },
      {
        "label": "US VIRGIN ISLANDS",
        "value": "VIR"
      },
      {
        "label": "UZBEKISTAN",
        "value": "UZB"
      },
      {
        "label": "VANUATU",
        "value": "VUT"
      },
      {
        "label": "VENEZUELA",
        "value": "VEN"
      },
      {
        "label": "VIETNAM",
        "value": "VNM"
      },
      {
        "label": "WALLIS AND FUTUNA",
        "value": "WLF"
      },
      {
        "label": "WESTERN SAHARA",
        "value": "ESH"
      },
      {
        "label": "YEMEN",
        "value": "YEM"
      },
      {
        "label": "ZAMBIA",
        "value": "ZMB"
      },
      {
        "label": "ZIMBABWE",
        "value": "ZWE"
      }
    ],
    countries: [        
          {            
            "label": "MALAYSIA",
            "value": "MYS"
          },
    ]
}

export default CountryMaster